var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "my-5 lg:my-15 2xl:my-20 text-center",
    class: {
      /*'h-96' : isSuggestionsListDisplayed*/
    }
  }, [_c('message-header', {
    staticStyle: {
      "z-index": "99"
    },
    attrs: {
      "message-header": _vm.messageHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4"
  }, [_c('h3', {
    staticClass: "col-start-4 col-span-6 mb-10"
  }, [_vm._v("\n            Partager le " + _vm._s(_vm.filetype) + " « " + _vm._s(_vm.filename) + " »\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-start-4 col-span-6 flex justify-center space-x-5 mt-10"
  }, [_c('search-bar', {
    attrs: {
      "name": "share",
      "libelle": "Partager",
      "value": _vm.search,
      "placeholder": "Ajouter des personnes ou des groupes",
      "big": false,
      "inherits": false,
      "has-border": true,
      "has-suggestion": true
    },
    on: {
      "input": function (newValue) {
        _vm.search = newValue;
      },
      "displaySuggestionsList": function (state) {
        _vm.displaySuggestionsList(state);
      }
    },
    scopedSlots: _vm._u([{
      key: "suggestionsList",
      fn: function () {
        return [_vm.isSuggestionsListDisplayed ? _c('div', _vm._l(_vm.membersFilterSearch, function (member, memberIndex) {
          return _c('div', {
            key: memberIndex,
            staticClass: "h-20 cursor-default grid grid-cols-12 items-center bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100",
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.selectMember(member);
              }
            }
          }, [_c('div', {
            staticClass: "col-span-2 place-self-center"
          }, [_c('div', {
            staticClass: "h-full w-full px-2"
          }, [_c('ProfilePicture', {
            attrs: {
              "size": "max-w-12 w-12 h-12",
              "other-object": member
            }
          })], 1)]), _vm._v(" "), member.username ? _c('div', {
            staticClass: "grid grid-cols-12 gap-x-4 col-span-10 text-left ml-4"
          }, [_c('div', {
            staticClass: "grid-cols-12 gap-x-4",
            class: {
              'col-span-6': !_vm.memberHasAccessToDepotDoc(member),
              'col-span-full': _vm.memberHasAccessToDepotDoc(member)
            }
          }, [_c('div', {
            staticClass: "text-lg font-normal col-span-full truncate"
          }, [_c('span', {
            staticClass: "userFirstNameDiv"
          }, [_vm._v(_vm._s(member.firstname + ' '))]), _vm._v(" "), _c('span', {
            staticClass: "uppercase userLastNameDiv"
          }, [_vm._v(_vm._s(member.lastname))])]), _vm._v(" "), _c('div', {
            staticClass: "col-span-full text-sm text-gray-600"
          }, [_vm._v("\n                          " + _vm._s(_vm.mainRole(member).display_name) + "\n                        ")])]), _vm._v(" "), _vm.memberIsBeneficiary(member) && !_vm.memberHasAccessToDepotDoc(member) ? _c('span', {
            staticClass: "col-span-6 my-auto text-pink-600 text-2sm italic font-light"
          }, [_vm._v("\n                        Cet utilisateur n'a pas accès au module dépôt de\n                        documents\n                      ")]) : !_vm.memberHasAccessToDepotDoc(member) ? _c('span', {
            staticClass: "col-span-6 my-auto text-pink-600 text-2sm italic font-light"
          }, [_vm._v("\n                        Le rôle «" + _vm._s(_vm.mainRole(member).display_name) + "» n'a pas\n                        accès au module dépôt de documents\n                      ")]) : _vm._e()]) : _c('div', {
            staticClass: "grid grid-cols-12 gap-x-4 col-span-10 text-left ml-4"
          }, [_c('div', {
            staticClass: "grid-cols-12 gap-x-4 col-span-6",
            class: {
              'col-span-6': !_vm.roleHasAccessToDepotDoc(member),
              'col-span-full': _vm.roleHasAccessToDepotDoc(member)
            }
          }, [_c('div', {
            staticClass: "text-lg font-normal col-span-full truncate roleNameDiv"
          }, [_vm._v("\n                          " + _vm._s(member.display_name) + "\n                        ")]), _vm._v(" "), member.company_id == null ? _c('div', {
            staticClass: "col-span-full text-sm text-gray-600"
          }, [_vm._v("\n                          Role par défaut\n                        ")]) : _vm._e()]), _vm._v(" "), !_vm.roleHasAccessToDepotDoc(member) ? _c('span', {
            staticClass: "col-span-6 my-auto text-pink-600 text-2sm italic font-light"
          }, [_vm._v("\n                        Ce rôle n'a pas accès au module dépôt de documents\n                      ")]) : _vm._e()])]);
        }), 0) : _vm._e()];
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-start-4 col-span-6 flex justify-center space-x-5 mt-10"
  }, [_vm.selectedMembersFlat.length > 0 ? _c('div', {
    staticClass: "flex flex-row flex-wrap items-center justify-start h-full gap-2 max-h-36 p-1 rounded-md border-indigo-600 border w-full border-opacity-50 overflow-y-scroll"
  }, _vm._l(_vm.selectedMembersFlat, function (selected, selectedIndex) {
    return _c('div', {
      key: selectedIndex
    }, [selected.username ? _c('tag', {
      attrs: {
        "libelle": selected.firstname + ' ' + selected.lastname.toUpperCase(),
        "theme-color": _vm.roleColor(selected),
        "is-closeable": true
      },
      on: {
        "close": function ($event) {
          return _vm.deselectMember(true, selectedIndex);
        }
      }
    }) : _c('tag', {
      attrs: {
        "libelle": selected.display_name,
        "theme-color": _vm.roleColor(selected),
        "is-closeable": true
      },
      on: {
        "close": function ($event) {
          return _vm.deselectMember(false, selectedIndex);
        }
      }
    })], 1);
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-start-4 col-span-6 grid grid-cols-12 gap-x-4 mt-10 items-end"
  }, [_c('div', {
    staticClass: "col-span-9"
  }, [_c('input-select', {
    attrs: {
      "libelle": 'Droits d\'accès',
      "name": "access_rights",
      "value": "Lecteur",
      "datas": [{
        value: 'Administrateur'
      }, {
        value: 'Editeur'
      }, {
        value: 'Lecteur'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.accessRights = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 h-full flex items-end justify-end"
  }, [_c('action-button', {
    staticClass: "h-2/3",
    attrs: {
      "libelle": "partager",
      "uppercase": true,
      "bg-color": "bg-indigo-600",
      "text-color": "text-white"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.shareFolder();
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-start-1 col-span-full my-5 text-red-500 text-sm text-center"
  }, [_vm._v("\n            " + _vm._s(((_vm.errors || [])['forbidden'] || [])[0]) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-start-1 col-span-full grid grid-cols-12 mt-20 items-center -mx-6 mb-3"
  }, [_c('h3', {
    staticClass: "col-start-2 col-span-full text-indigo-600 text-2xl text-left mb-4"
  }, [_vm._v("\n              Membres du partage\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-start-2 col-span-4 mb-6"
  }, [_c('input-select', {
    attrs: {
      "name": "memberDisplay",
      "libelle": "Affichage",
      "value": _vm.memberDisplay,
      "datas": [{
        value: 'Tout'
      }, {
        value: 'Utilisateurs'
      }, {
        value: 'Groupes'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.memberDisplay = newValue;
      }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "col-start-2 col-span-5 text-left text-lg text-gray-600"
  }, [_vm._v("Membres")]), _vm._v(" "), _c('span', {
    staticClass: "col-start-7 col-span-3 text-left text-lg text-gray-600"
  }, [_vm._v("Droits d'accès")]), _vm._v(" "), _c('span', {
    staticClass: "col-start-10 col-span-3 text-left text-lg text-gray-600"
  }, [_vm._v("Révoquer les droits")])]), _vm._v(" "), _vm._l(_vm.folderUsersSort, function (user, userIndex) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.memberDisplay == 'Tout' || _vm.memberDisplay == 'Utilisateurs',
        expression: "memberDisplay == 'Tout' || memberDisplay == 'Utilisateurs'"
      }],
      key: userIndex,
      staticClass: "col-start-1 col-span-full grid grid-cols-12 items-center min-h-24 even:bg-indigo-200 -mx-6"
    }, [_c('div', {
      staticClass: "col-start-2 col-span-5 grid grid-cols-12 items-center"
    }, [_c('div', {
      staticClass: "col-start-1 col-span-2"
    }, [_c('ProfilePicture', {
      attrs: {
        "size": "max-w-12 w-12 h-12",
        "other-object": user
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-start-3 text-left col-span-full grid grid-cols-12 items-center"
    }, [_c('div', {
      staticClass: "text-lg font-normal col-span-full"
    }, [_c('span', {
      staticClass: "userFirstNameDiv"
    }, [_vm._v(_vm._s(user.firstname + ' '))]), _c('span', {
      staticClass: "uppercase userLastNameDiv"
    }, [_vm._v(_vm._s(user.lastname))])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-full text-sm text-gray-600"
    }, [_vm._v("\n                  " + _vm._s(_vm.mainRole(user).display_name) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-start-7 col-span-2"
    }, [_c('input-select', {
      attrs: {
        "name": 'access_rights' + userIndex,
        "value": _vm.fileRoleFromFileRights(user.pivot.role),
        "datas": [
        /*
        { value: 'Propriétaire' },
        */
        {
          value: 'Administrateur'
        }, {
          value: 'Editeur'
        }, {
          value: 'Lecteur'
        }],
        "disabled": user.pivot.role === 'owner'
      },
      on: {
        "input": function (newValue) {
          user.newRights = newValue;
          _vm.changeRights(userIndex, user, newValue);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.editedMembers.includes(userIndex),
        expression: "editedMembers.includes(userIndex)"
      }],
      key: userIndex,
      staticClass: "col-start-9 col-span-1",
      on: {
        "click": function ($event) {
          _vm.$emit('editUserRights', user, user.newRights), _vm.editedMembers = _vm.editedMembers.filter(function (memberIndex) {
            return memberIndex !== userIndex;
          });
        }
      }
    }, [_c('div', {
      staticClass: "w-1/4 cursor-pointer flex ml-6"
    }, [_c('span', {
      staticClass: "flex items-center justify-center flex-none rounded-full border border-teal-600 h-8 w-8 bg-teal-300 text-teal-600 border-opacity-25"
    }, [_c('icon', {
      attrs: {
        "name": "checkmark"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "col-start-10 col-span-3"
    }, [_c('div', {
      on: {
        "click": function ($event) {
          return _vm.$emit('revokeUserRights', user);
        }
      }
    }, [user.pivot.role !== 'owner' && _vm.isOwner ? _c('close-button') : _vm._e()], 1)])]);
  }), _vm._v(" "), _vm._l(_vm.folderRolesSort, function (role, roleIndex) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.memberDisplay == 'Tout' || _vm.memberDisplay == 'Groupes',
        expression: "memberDisplay == 'Tout' || memberDisplay == 'Groupes'"
      }],
      key: (roleIndex + 1) * 9999,
      staticClass: "col-start-1 col-span-full grid grid-cols-12 items-center min-h-24 even:bg-indigo-200 -mx-6"
    }, [_c('div', {
      staticClass: "col-start-2 col-span-5 grid grid-cols-12 items-center"
    }, [_c('div', {
      staticClass: "col-start-1 col-span-2"
    }, [_c('div', {
      staticClass: "rounded-full bg-indigo-200 w-12 h-12 flex items-center justify-center text-xl text-indigo-600"
    }, [_c('p', [_vm._v("\n                    " + _vm._s(role.display_name.charAt(0).toUpperCase()) + "\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-start-3 text-left col-span-full grid grid-cols-12 items-center"
    }, [_c('div', {
      staticClass: "text-lg font-normal col-span-full"
    }, [_c('span', [_vm._v(_vm._s(role.display_name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-full text-sm text-gray-600"
    }, [_vm._v("\n                  " + _vm._s('Groupe de ' + role.display_name.toLowerCase()) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-start-7 col-span-2"
    }, [_c('input-select', {
      attrs: {
        "name": 'access_rights' + (roleIndex + 1) * 9999,
        "value": _vm.fileRoleFromFileRights(role.pivot.role),
        "datas": [{
          value: 'Administrateur'
        }, {
          value: 'Editeur'
        }, {
          value: 'Lecteur'
        }],
        "disabled": role.pivot.role === 'owner'
      },
      on: {
        "input": function (newValue) {
          role.newRights = newValue;
          _vm.changeRights((roleIndex + 1) * 9999, role, newValue);
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.editedMembers.includes((roleIndex + 1) * 9999),
        expression: "editedMembers.includes((roleIndex + 1) * 9999)"
      }],
      key: (roleIndex + 1) * 9999,
      staticClass: "col-start-9 col-span-1",
      on: {
        "click": function ($event) {
          _vm.$emit('editRoleRights', role, role.newRights);
          _vm.editedMembers = _vm.editedMembers.filter(function (memberIndex) {
            return memberIndex !== (roleIndex + 1) * 9999;
          });
        }
      }
    }, [_c('div', {
      staticClass: "w-1/4 cursor-pointer flex ml-6"
    }, [_c('span', {
      staticClass: "flex items-center justify-center flex-none rounded-full border border-teal-600 h-8 w-8 bg-teal-300 text-teal-600 border-opacity-25"
    }, [_c('icon', {
      attrs: {
        "name": "checkmark"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "col-start-10 col-span-3"
    }, [_vm.isOwner ? _c('div', {
      on: {
        "click": function ($event) {
          return _vm.$emit('revokeRoleRights', role);
        }
      }
    }, [_c('close-button')], 1) : _vm._e()])]);
  })], 2)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }